<div class="row">
  <div class="col-md-6">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">SPEC</h3>
      </div>
      <form class="form-horizontal">
        <div class="card-body">
          <div class="form-group row">
            <app-material-pg-input 
              class="col-md-6"
              label="Year Built"
              type="number"
              name="newVesselYearBuilt"
              id="newVesselYearBuilt"
              [ngModel]="versionedVessel?.data?.spec!.yearBuilt"
              (ngModelChange)="versionedVessel.data!.spec!.yearBuilt = $event"
              tabindex="1"
              [required]="true">
            </app-material-pg-input>
            <app-material-auto-complete 
              class="col-md-6"
              name="newVesselaisVesselType"
              id="newVesselaisVesselType"
              [ngModel]="versionedVessel?.data?.spec?.vesselType"
              (ngModelChange)="versionedVessel.data!.spec!.vesselType = $event"
              tabindex="2"
              [placeholder]="'Vessel Type'"
              [items]="(vesselTypes | async) ?? []"
              [formatter]="vesselTypeFormatter"
              [required]="true">
            </app-material-auto-complete>
          </div>
          <div class="form-group row">
            <app-material-pg-input 
              class="col-md-6"
              label="GRT (ton)"
              type="number"
              name="newVesselGRT"
              id="newVesselGRT"
              [ngModel]="versionedVessel?.data?.spec!.dimensionsCapacities!.grt"
              (ngModelChange)="versionedVessel.data!.spec!.dimensionsCapacities!.grt = $event"
              tabindex="3"
              [required]="true">
            </app-material-pg-input>
            <app-material-pg-input 
              class="col-md-6"
              label="NRT (ton)"
              type="number"
              name="newVesselNRT"
              id="newVesselNRT"
              [ngModel]="versionedVessel?.data?.spec!.dimensionsCapacities!.nrt"
              (ngModelChange)="versionedVessel.data!.spec!.dimensionsCapacities!.nrt = $event"
              tabindex="4"
              [required]="true">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input 
              class="col-md-12"
              label="Capacity (m³)"
              type="number"
              name="newVesselCapacity"
              id="newVesselCapacity"
              [ngModel]="versionedVessel?.data?.spec!.dimensionsCapacities!.capacity"
              (ngModelChange)="versionedVessel.data!.spec!.dimensionsCapacities!.capacity = $event"
              tabindex="5"
              [required]="true">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input 
              class="col-md-12"
              label="Draft(meter)"
              type="number"
              name="newVesselDraft"
              id="newVesselDraft"
              [ngModel]="versionedVessel?.data?.spec!.dimensionsCapacities!.draft"
              (ngModelChange)="versionedVessel.data!.spec!.dimensionsCapacities!.draft = $event"
              tabindex="6"
              [required]="true">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input 
              class="col-md-6"
              label="Dead weight (ton)"
              type="number"
              name="newVesselDeadWeight"
              id="newVesselDeadWeight"
              [ngModel]="versionedVessel?.data?.spec!.dimensionsCapacities!.deadWeight"
              (ngModelChange)="versionedVessel.data!.spec!.dimensionsCapacities!.deadWeight = $event"
              tabindex="7"
              [required]="true">
            </app-material-pg-input>
            <app-material-pg-input 
              class="col-md-6"
              label="LOA (meter)"
              type="number"
              name="newVesselLengthOverall"
              id="newVesselLengthOverall"
              [ngModel]="versionedVessel?.data?.spec!.dimensionsCapacities!.loa"
              (ngModelChange)="versionedVessel.data!.spec!.dimensionsCapacities!.loa = $event"
              tabindex="8"
              [required]="true">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input 
              class="col-md-6"
              label="Beam (meter)"
              type="number"
              name="newVesselBeem"
              id="newVesselBeem"
              [ngModel]="versionedVessel?.data?.spec!.dimensionsCapacities!.beam"
              (ngModelChange)="versionedVessel.data!.spec!.dimensionsCapacities!.beam = $event"
              tabindex="9"
              [required]="true">
            </app-material-pg-input>
            <app-material-pg-input 
              class="col-md-6"
              label="Lightship (ton)"
              type="number"
              name="lightShip"
              id="lightShip"
              [ngModel]="versionedVessel?.data?.spec!.dimensionsCapacities!.lightShip"
              (ngModelChange)="versionedVessel.data!.spec!.dimensionsCapacities!.lightShip = $event"
              tabindex="10">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input 
              class="col-md-12"
              label="Email address"
              type="email"
              placeholder="name@example.com"
              name="email"
              id="email"
              [ngModel]="versionedVessel?.data?.spec!.email"
              (ngModelChange)="versionedVessel.data!.spec!.email = $event"
              tabindex="11">
            </app-material-pg-input>
          </div>
          <div class="row">
            <app-material-pg-input 
              class="col-md-12"
              label="Number Of Tanks"
              type="number"
              name="numberOfTanks"
              id="numberOfTanks"
              [ngModel]="versionedVessel?.data?.spec!.dimensionsCapacities!.numberOfTanks"
              (ngModelChange)="versionedVessel.data!.spec!.dimensionsCapacities!.numberOfTanks = $event"
              tabindex="12"
              [required]="true">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input 
              class="col-md-6"
              label="Last dry dock"
              type="date"
              id="lastDryDock"
              name="lastDryDock"
              [(ngModel)]="lastDryDock"
              [required]="true"
              tabindex="13">
            </app-material-pg-input>
            <app-material-pg-input 
              class="col-md-6"
              label="Next dry dock"
              type="date"
              id="nextDryDock"
              name="nextDryDock"
              [(ngModel)]="nextDryDock"
              [required]="true"
              tabindex="14">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-organisation-selector 
              id="owner"
              class="pg-component"
              [(ngModel)]="owner"
              [organisationLanguage]="'en'"
              name="owner"
              [organisations]="owners"
              tabindex="15"
              [placeholder]="'Owner'"
              [required]="true">
            </app-material-organisation-selector>
          </div>
          <div class="form-group row">
            <app-material-organisation-selector 
              id="technical"
              class="pg-component"
              [(ngModel)]="technical"
              [organisationLanguage]="'en'"
              name="technical"
              [placeholder]="'Technical Operator'"
              tabindex="16"
              [organisations]="technicals"
              [required]="true">
            </app-material-organisation-selector>
          </div>
          <div class="form-group row">
            <app-material-organisation-selector 
              id="vesselBuilder"
              class="pg-component"
              [(ngModel)]="vesselBuilder"
              [organisationLanguage]="'en'"
              name="vesselBuilder"
              [organisations]="builders"
              [placeholder]="'Vessel Builder'"
              tabindex="17"
              [required]="true">
            </app-material-organisation-selector>
          </div>
          <div class="form-group row">
            <app-material-organisation-selector 
              id="protector"
              class="pg-component"
              [(ngModel)]="protector"
              [organisationLanguage]="'en'"
              name="protector"
              [placeholder]="'Protection and Indemnity'"
              tabindex="18"
              [organisations]="protectors"
              [required]="true">
            </app-material-organisation-selector>
          </div>
          <div class="form-group row">
            <app-material-organisation-selector 
              id="manager"
              class="pg-component"
              [(ngModel)]="manager"
              [organisationLanguage]="'en'"
              name="manager"
              tabindex="19"
              [placeholder]="'Manager Operator'"
              [organisations]="managers"
              [required]="true">
            </app-material-organisation-selector>
          </div>
          <div class="row">
            <app-material-pg-input 
              class="col-md-6"
              label="Charter party speed"
              type="number"
              name="economicalLadenSpeed"
              id="economicalLadenSpeed"
              placeholder="Economical Laden Speed"
              [(ngModel)]="economicalLadenSpeed"
              [required]="true"
              tabindex="20">
            </app-material-pg-input>
            <app-material-pg-input 
              class="col-md-6"
              label="Maximum Ballast Speed"
              type="number"
              name="maximumBallastSpeed"
              id="maximumBallastSpeed"
              placeholder="Maximum Ballast Speed"
              [(ngModel)]="maximumBallastSpeed"
              [required]="true"
              tabindex="20">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-organisation-selector 
              id="commercial"
              class="pg-component"
              [(ngModel)]="commercial"
              [organisationLanguage]="'en'"
              name="commercial"
              placeholder="Commercial Operator"
              tabindex="21"
              [organisations]="commercials"
              [required]="true">
            </app-material-organisation-selector>
          </div>
          <div class="row">
            <app-material-chunk-file-uploader 
              [accept]="'.xlsx'"
              name="document"
              [ngModel]="doc2"
              (ngModelChange)="uploadDocument($event)">
            </app-material-chunk-file-uploader>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-12">
                <app-material-pg-button 
                  id="newVessel"
                  class="pull-right"
                  label="Save"
                  (clicked)="save()">
                </app-material-pg-button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>